(function () {
  if (typeof window.isADI === 'undefined' || window.isADI !== true) return;

  var PRICE_API_URL = 'https://wsvianneymx-dot-mx-vianney-001.uc.r.appspot.com/api/convertidor';
  var priceTable = null;
  var priceTablePromise = null;

  function fetchPriceTable() {
    if (priceTablePromise) return priceTablePromise;
    priceTablePromise = fetch(PRICE_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pais: 'CR' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        priceTable = data;
        return data;
      })
      .catch(function (err) {
        console.warn('[limespot-adi-price-fix] No se pudo obtener la tabla de precios ADI', err);
        return null;
      });
    return priceTablePromise;
  }

  function formatCRC(value) {
    var intVal = Math.round(value);
    var withSpaces = String(intVal).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return '₡' + withSpaces;
  }

  function applyAdiPriceToItem(itemEl) {
    if (itemEl.dataset.adiPriceApplied === 'true') return;
    var clienteFinalPrice = itemEl.getAttribute('data-price');
    if (!clienteFinalPrice || !priceTable || !priceTable[clienteFinalPrice]) return;

    var adiPrice = priceTable[clienteFinalPrice].precioAdi;
    var priceSpan = itemEl.querySelector('.ls-price.money');
    if (priceSpan) {
      priceSpan.setAttribute('data-numeric-value', adiPrice);
      priceSpan.textContent = formatCRC(adiPrice);
    }
    itemEl.dataset.adiPriceApplied = 'true';
  }

  function applyAdiPricesToAllVisible() {
    if (!priceTable) return;
    document.querySelectorAll('.limespot-recommendation-box-item').forEach(applyAdiPriceToItem);
  }

  fetchPriceTable().then(function () {
    applyAdiPricesToAllVisible();
  });

  // Limespot inyecta el carrusel de forma asíncrona (a veces más de una
  // vez), así que este observer detecta cuando aparecen nuevos productos
  // y les aplica el precio ADI apenas se pintan.
  var observer = new MutationObserver(function () {
    if (priceTable) {
      applyAdiPricesToAllVisible();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();